import { BankInfoController as controller } from './bankInfo.controller';
import template from './bankInfo.html';

export const bankInfoComponent = {
  name: 'bankInfoComponent',
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    returnTo: '<',
  },
};
